module.exports = __webpack_public_path__ + "img/bread-slice.2a273298.svg";